import type { ReactNode } from 'react';
import { useSiteChoices } from '../../context/SiteChoicesContext';

interface PrivacySettingsButtonProps {
  children?: ReactNode;
  className?: string;
}

export default function PrivacySettingsButton({
  children = 'Préférences cookies',
  className,
}: PrivacySettingsButtonProps) {
  const { openPreferences } = useSiteChoices();

  return (
    <button
      type="button"
      className={className || 'privacy-settings-button'}
      onClick={openPreferences}
    >
      {children}
    </button>
  );
}
